import { render, staticRenderFns } from "./Card3.vue?vue&type=template&id=449a530c&scoped=true&"
import script from "./Card3.vue?vue&type=script&lang=js&"
export * from "./Card3.vue?vue&type=script&lang=js&"
import style0 from "./Card3.vue?vue&type=style&index=0&id=449a530c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449a530c",
  null
  
)

export default component.exports